<template>
    <!-- 该组件用于学习报告和我的作品页的视频播放，其他需要自动播放的场景不建议使用，在ios14存在播放的兼容问题 -->
    <div class="panel">
        <!-- 该区域用于不需要进度条等控件的情形,用于点击视频控制播放暂停 -->
        <div
            v-show="!controls"
            class="shadow-bg"
            @click="videoHandle(false)"
        >
            <img v-show="showPlayBtn" class="player" :src="playImg" alt="播放">
        </div>
        <!-- 有合成好的视频的话，直接播合成好的视频 :muted="ismuted" -->
        <video
            v-if="!!pageData.opusVideoMix"
            :id="tagIndex"
            :class="['oss-work-video', videoBorder]"
            :controls="controls"
            controlsList="nodownload"
            preload="auto"
            :loop="loop"
            :autoplay="autoplay"
            raw-controls
            controls360
            webkit-playsinline="true"
            playsinline="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-video-orientation="portraint"
            :poster="pageData.courseCover || pageData.coverImage"
            :src="pageData.opusVideoMix"
            @play="videoPlay"
            @pause="myVideoPause"
            @ended="myVideoEnded"
        >
            <!-- <source :src="pageData.opusUrl" type="video/mp4"> -->
            暂无作品
        </video>
        <div v-else>
            <video
                :class="['work-video', videoBorder]"
                :controls="controls"
                controlsList="nodownload"
                preload="auto"
                :autoplay="autoplay"
                webkit-playsinline="true"
                playsinline="true"
                x5-playsinline="true"
                x-webkit-airplay="allow"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                x5-video-orientation="portraint"
                :poster="pageData.courseCover || pageData.coverImage"
                :src="pageData.opusVideo"
                @pause="videoPause"
                @play="videoPlay"
                @timeupdate="videoTimeupdate"
                @loadedmetadata="videoLoadedmetadata"
                @seeked="videoSeeked"
                @ended="videoEnded"
            >
                <!-- <source :src="pageData.opusUrl" type="video/mp4"> -->
                暂无作品
            </video>
            <audio
                id="report-audio"
                preload="auto"
                :src="pageData.opusUrl"
                style="display: none;"
                @timeupdate="audioTimeupdate"
                @ended="audioEnded"
            ></audio>
        </div>
        <div v-show="!autoplay && videoPanelShow" class="video-panel" @click="handerVideo">
            <img class="poster" :src="pageData.courseCover || pageData.coverImage" style="object-fit:cover" alt="封面图">
            <div v-show="showShadow" class="vlayer"></div>
            <img class="player" :style="playStyle" :src="playImg" alt="播放">
        </div>
        <img class="down-img" v-if="needDownLoad" @click="downLoadWork" src="https://g.gsxcdn.com/2196130560_b2xmova2.png" alt="" srcset="">
    </div>
</template>
<script>
import {sendMessageApp, isWXBrower, isAndroid, isIOS} from '@/utils/utils';

export default {
    name: 'Myvideo',
    props: {
        tagIndex: {
            type: Number,
            default: 0
        },
        needDownLoad: {
            type: Boolean,
            default: false
        },
        playImg: {
            type: String,
            default() {
                return 'https://g.gsxcdn.com/1618847536_ndorwzhl.png';
            }
        },
        playStyle: {
            type: String,
            default: ''
        },
        pageData: {
            type: Object,
            default() {
                return {};
            }
        },
        showShadow: {
            type: Boolean,
            default: true
        },
        controls: {
            type: Boolean,
            default: true
        },
        loop: {
            type: Boolean,
            default: true
        },
        autoplay: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            oAudio: null,
            workVideo: null,
            videoBorder: '',
            videoPanelShow: true,
            showPlayBtn: true,
            ismuted: true,
        };
    },
    mounted() {
        // 安卓手机上 video 总是不能被遮住，不再配置 border-radius 圆角
        this.videoBorder = isAndroid() ? 'no-bdr' : '';
    },
    methods: {
        handerVideo(evt) {
            this.ismuted = false;
            /**
             * 此处再次获取video标签和audio标签是因为pageData数据请求是异步的，
             * 在vue的mounted生命周期中获取标签元素时pageData还没获取到，致使当前页面渲染不是最终dom
             */
            this.oAudio = document.querySelector('#report-audio');
            this.workVideo = document.querySelector('.work-video');
            const tagIndex = evt.srcElement.parentNode.parentNode.getElementsByTagName('video')[0].id;
            this.ossworkVideo = document.getElementById(tagIndex);
            // this.ossworkVideo = document.querySelector('.oss-work-video');
            console.log(this.pageData);
            this.$emit('gioreport');
            if (this.ossworkVideo) {
                console.log(this.ossworkVideo);
                this.ossworkVideo.play();
                this.$emit('changevideopaused', this.ossworkVideo.paused);
            }
            else {
                this.workVideo.play();
                if (isWXBrower() && isIOS()) {
                    this.oAudio && this.oAudio.play();
                }
            }
        },
        // 控制视频的播放暂停
        videoHandle() {
            if (!this.ossworkVideo) {
                return;
            }
            if (this.ossworkVideo.paused) {
                this.ossworkVideo.play();
                this.showPlayBtn = false;
            }
            else {
                this.ossworkVideo.pause();
                this.showPlayBtn = true;
            }
            this.$emit('changevideopaused', this.ossworkVideo.paused);
        },
        myVideoEnded(e) {
            this.videoPanelShow = true;
            this.showPlayBtn = true;
            this.$emit('videoended');
        },
        myVideoPause() {
            this.$emit('videopause');
        },
        pauseVideo() {
            this.ossworkVideo && this.ossworkVideo.pause();
            this.workVideo && this.workVideo.pause();
        },
        videoPlay(e) {
            this.ismuted = false;
            this.showPlayBtn = false;
            this.videoPanelShow = false;
            const allVideos = document.querySelectorAll('.oss-work-video');
            const arr = [...allVideos];
            arr.forEach(item => {
                if (item.id !== e.srcElement.id) {
                    item.pause();
                }
            });
            this.$emit('stop-other');
            this.$emit('changevideopaused', 'autoplay');
            if (isWXBrower() && isAndroid()) {
                this.oAudio && this.oAudio.play();
            }
        },
        videoPause(e) {
            this.oAudio.pause();
            this.$emit('videopause');
        },
        videoSeeked(e) {
            if (this.oAudio) {
                this.oAudio.currentTime = e.srcElement.currentTime;
                this.oAudio.play();
            }
        },
        videoTimeupdate(e) {
            const {oAudio} = this;

            if (oAudio && oAudio.paused) {
                try {
                    oAudio.currentTime = e.srcElement.currentTime;
                    oAudio.play();
                }
                catch (err) {
                    console.log('err', err);
                }
            }
        },
        audioTimeupdate(e) {
        },
        videoLoadedmetadata(e) {
            console.log('videoLoadedmetadata', e.srcElement.duration);
        },
        videoEnded(e) {
            e.srcElement.play();
            this.oAudio.currentTime = 0;
            this.oAudio.play();
        },
        audioEnded(e) {
        },
        // 下载作品
        downLoadWork() {
            sendMessageApp('downloadVideo', {
                url: this.pageData.opusVideoMix,
                courseId: this.pageData.courseId,
                course: `${this.pageData.courseName}${this.pageData.courseTypeName}`,
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.panel {
    overflow: hidden;
    // border-radius: .21rem;
    overflow: hidden;

    .shadow-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 3;
        .player {
            position: absolute;
            z-index: 20;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width: 1.39rem;
            height: 1.39rem;
        }
    }

    .work-video, .oss-work-video{
        width: 100%;
        height: 100%;
        background: #FFFCF9;
        // border-radius: 0.34rem;
    }
    .no-bdr {
        border-radius: unset;
    }

    .video-panel{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        overflow: hidden;
        box-sizing: border-box;

        .poster {
            width: 100%;
            height: 100%;
            background: #FFFCF9;
            // border-radius: 0.34rem;
        }
        .vlayer {
            position: absolute;
            z-index: 10;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            // border-radius: 0.34rem;
            background: #000;
            opacity: 0.3;
            transform: translateZ(11px);
        }
        .player {
            position: absolute;
            z-index: 20;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width: 1.39rem;
            height: 1.39rem;
        }
    }
    .down-img {
        width: .86rem;
        height: .86rem;
        position: absolute;
        top: .2rem;
        right: .2rem;
        z-index: 11;
    }
}

</style>
